import { render, staticRenderFns } from "./NotificationBadge.vue?vue&type=template&id=44bfa73c"
import script from "./NotificationBadge.vue?vue&type=script&lang=js"
export * from "./NotificationBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports